import { useMutation } from '@tanstack/react-query'

import { marketShopAPI } from '@/api/new-api'
import { MarketShopDeliveryType, MarketShopMobilePaymentMethod } from '@/models'

export interface CreateMarketShopMobilePaymentRequest {
  sessionId: string
  deliveryType: MarketShopDeliveryType
  orderNotes?: string
  tipAmount?: number
  // Note: When `cash`, the server may omit `clientSecret` in the response.
  paymentMethod?: MarketShopMobilePaymentMethod
}

export interface CreateMarketShopMobilePaymentResponse {
  orderId: number
  clientSecret?: string
  totalAmount: number
  deliveryType: MarketShopDeliveryType
  orderNotes: string
}

export const createMarketShopMobilePayment = async (data: CreateMarketShopMobilePaymentRequest) => {
  const response = await marketShopAPI.post<CreateMarketShopMobilePaymentResponse>(
    `/market-shop/mobile-pay`,
    data,
  )
  return response.data
}

export const useCreateMarketShopMobilePayment = () => {
  return useMutation({
    mutationFn: createMarketShopMobilePayment,
  })
}
